<template>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        :retain-focus="false"
        persistent
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn 
                v-bind="attrs"
                v-on="on" 
                x-medium
                large block 
                rounded 
                color="primary"
                dark>
                Agregar Bono
            </v-btn>
        </template>
        <v-card>
            <v-toolbar
              dark
              color="secondary">
                <v-btn
                    icon
                    dark
                    class="btn btn-primary"
                    @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                
                <v-toolbar-title>Agregar Bono</v-toolbar-title>

                <template v-slot:extension>
                  <v-tabs v-model="tab" align-with-title>
                    <v-tabs-slider color="accent"></v-tabs-slider>

                    <v-tab v-for="item in items" :key="item">
                      {{ item }}
                    </v-tab>
                  </v-tabs>
                </template> 

            </v-toolbar>

            <v-tabs-items v-model="tab" class="container mt-5">
              
              <v-tab-item>
                <div class="container mt-4">
                  <addBonus/>
                </div>
              </v-tab-item>

          </v-tabs-items>
  
        </v-card>
    </v-dialog>
  
</template>
  
<script>

  import addBonus from '@/views/bonus/pages/add_bonus/components/form_add_bonus_component.vue';
  import  EventBus  from '@/utils/event_bus.js';

  export default {
    
    name:"addBonusPage",
    components: {
      addBonus,
    },
    data () {
      return {
        dialog: false,
        tab: null,
        items: [
          "Datos Completos"
        ],
   
      }
      
    },

    async mounted() {
      EventBus.$on('formBonus-submitted-successfully', () => {
        this.closeDialog()
        EventBus.$emit('reload-bonus');
      });
    },

    methods: {
      closeDialog() {

      this.$store.commit('RESET_STATE');
      this.dialog = false;

      window.location.reload();

      },
    },
  
    computed: { 
   
    }
  };
</script>
  